import { render } from "./DesktopBar.vue?vue&type=template&id=27e82ec5&scoped=true"
import script from "./DesktopBar.vue?vue&type=script&lang=js"
export * from "./DesktopBar.vue?vue&type=script&lang=js"

import "./DesktopBar.vue?vue&type=style&index=0&id=27e82ec5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27e82ec5"]])

export default __exports__